import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const withAdminAuth = <P extends object>(
  WrappedComponent: React.ComponentType<P>
) => {
  const AdminProtectedComponent: React.FC<P> = (props) => {
    const { user, isAdmin, loading } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
      if (!loading) {
        if (!user || !isAdmin) {
          navigate('/adminlogin');
        }
      }
    }, [user, isAdmin, loading, navigate]);

    if (loading) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-white">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-royal-purple"></div>
        </div>
      );
    }

    if (!user || !isAdmin) {
      return null;
    }

    return <WrappedComponent {...props} />;
  };

  return AdminProtectedComponent;
};
